import Button from '@/common/components/Button'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { FormTransformers } from '@/common/utils/formTransformers'
import { MaintenanceForwardingEstablishmentChoiceEntryData } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwarding.type'
import { useMaintenanceEstablishmentChoiceManualEntryProposalsClientAccept } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/establishmentChoice/manualEntryProposals/useMaintenanceEstablishmentChoiceManualEntryProposalsClientAccept'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

interface ManualEntryProposalsClientAcceptProps {
  proposal: MaintenanceForwardingEstablishmentChoiceEntryData['actual_proposal']
}

const ManualEntryProposalsClientAccept = ({ proposal }: ManualEntryProposalsClientAcceptProps) => {
  const { id } = useParams()

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const queryClient = useQueryClient()

  const { mutate: clientAccept, isPending: clientAcceptIsPending } =
    useMaintenanceEstablishmentChoiceManualEntryProposalsClientAccept({
      proposalId: proposal.id,
      options: {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: ['maintenanceWorkflow', id] })
          queryClient.invalidateQueries({ queryKey: ['maintenanceWorkflowForwardings', id] })
          queryClient.invalidateQueries({ queryKey: ['maintenanceForwarding'] })
        },
        onError: (error) => {
          FormTransformers.errorsTransformer({
            setMessages,
          })(error)
        },
      },
    })

  return (
    <>
      <Button
        variant="success"
        operationKlassToCheckPermission="Client::Maintenance::EstablishmentChoice::ManualEntryProposals::ClientAccept"
        onClick={() => clientAccept()}
        isLoading={clientAcceptIsPending}
      >
        Aceitar
      </Button>

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}

export default ManualEntryProposalsClientAccept
